import { Users } from "lucide-react";

export interface User {
  id: string;
  name: string;
  avatar?: string;
}

interface UserSelectorProps {
  users: User[];
  selectedUser: User;
  onUserSelect: (user: User) => void;
}

const UserSelector = ({ users, selectedUser, onUserSelect }: UserSelectorProps) => {
  return (
    <div className="px-6 py-4">
      <div className="flex items-center gap-2 mb-3">
        <Users className="w-4 h-4 text-stats-icon" />
        <span className="text-sm text-time-secondary">Select User</span>
      </div>
      
      <div className="flex gap-3">
        {users.map((user) => (
          <button
            key={user.id}
            onClick={() => onUserSelect(user)}
            className={`
              flex-1 p-3 rounded-xl border-2 transition-all duration-300
              ${selectedUser.id === user.id
                ? 'border-primary bg-primary/5 shadow-soft'
                : 'border-border bg-card hover:border-primary/30'
              }
            `}
          >
            <div className="flex flex-col items-center gap-2">
              <div className={`
                w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm
                ${selectedUser.id === user.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-secondary text-secondary-foreground'
                }
              `}>
                {user.name.charAt(0).toUpperCase()}
              </div>
              <span className={`
                text-sm font-medium
                ${selectedUser.id === user.id
                  ? 'text-primary'
                  : 'text-time-display'
                }
              `}>
                {user.name}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default UserSelector;